exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dropdown-meatball-toggle-component{padding:12px;cursor:pointer}", ""]);

// exports
